window.ragazzi = {
    handleTouchHints () {
        let productSliderTouchHint = localStorage.getItem('ragazziProductSliderTouchHint');
        productSliderTouchHint = parseInt(productSliderTouchHint) || 0;
        if (!productSliderTouchHint || productSliderTouchHint < 5) {
            window.ragazzi?.showProductSliderTouchHint();
            productSliderTouchHint = typeof productSliderTouchHint === "number" ? productSliderTouchHint + 1 : 1;
            localStorage.setItem('ragazziProductSliderTouchHint', productSliderTouchHint.toString());
        }
    },
    showProductSliderTouchHint () {
        window.ragazzi.productSliders = document.querySelectorAll('.swiper-product-card--slider');
        window.ragazzi.productSliders.forEach((slider) => {
            const touchIcon = slider.parentNode.querySelector('.js-touch-icon');
            touchIcon.style.animation = 'fade ease-in-out 3s infinite';

            if (slider.swiper) {
                slider.swiper?.on('sliderFirstMove', function () {
                    window.ragazzi.hideProductSliderTouchHint();
                });
            }
        })
    },
    hideProductSliderTouchHint () {
        window.ragazzi.productSliders.forEach((slider) => {
            const touchIcon = slider.parentNode.querySelector('.js-touch-icon');
            touchIcon.style.animation = '';
            touchIcon.opacity = '0';
        })
    },

    async getCollectionCount (handle) {
        const res = await fetch(`/collections/${handle}?view=count`);
        if (!res.ok) throw new Error('Fetch failed');
        return res.json();
    },
    addNewArrivalsDetails(count) {
        if (count === -1) return;
        const newArrivalsMenuItem = document.querySelector('.miscellaneous__items .menu__item-link[href="/collections/new-arrivals"] span');
        if (newArrivalsMenuItem) {
            const text = newArrivalsMenuItem.innerText+ ` (${count})`;
            newArrivalsMenuItem.dataset.hover = text;
            newArrivalsMenuItem.innerText = text;
        }

        const newArrivalsDrawerItem = document.querySelector('.menu-drawer .menu__item-link[href="/collections/new-arrivals"] span');
        if (newArrivalsDrawerItem) {
            const text = newArrivalsDrawerItem.innerText+ ` (${count})`;
            newArrivalsDrawerItem.dataset.hover = text;
            newArrivalsDrawerItem.innerText = text;
        }
    },
    addNewArrivalsCount () {
        let newArrivalsCount = sessionStorage.getItem('ragazziNewArrivalsCount');
        if (!newArrivalsCount) {
            window.ragazzi.getCollectionCount('new-arrivals')
                .then(data => {
                    const count = data.count ?? -1;
                    sessionStorage.setItem('ragazziNewArrivalsCount', count);
                    window.ragazzi.addNewArrivalsDetails(count);
                })
        } else {
            window.ragazzi.addNewArrivalsDetails(parseInt(newArrivalsCount));
        }
    }
}

window.ragazzi?.addNewArrivalsCount();

document.addEventListener('DOMContentLoaded', () => {
    window.ragazzi?.handleTouchHints();
})

// Alter delivery time, if we have a preorder item
window.addEventListener('stoq:loaded', (event) => {
    if (event.detail.pageType === 'product' && event.detail.enabled) {
        setTimeout(() => {
            const addToCart = document.querySelector('[data-ragazzi-add-to-cart]');
            const deliveryDefault = document.querySelector('[data-ragazzi-delivery-default]');
            const deliveryPreorder = document.querySelector('[data-ragazzi-delivery-preorder]');
            if (!addToCart || !deliveryDefault || !deliveryPreorder) return;

            if (addToCart.classList.contains('restock-rocket-preorder-button')) {
                deliveryDefault.style.display = 'none';
                deliveryPreorder.style.display = 'block';
            }
        }, 500);
    }
});